// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { DealerDetailsPageContext } from "@insite/content-library/Pages/DealerDetailsPage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { screen } from "@mcmc/XDL/Helpers";
import React from "react";
import { css } from "styled-components";

export interface DealerDetailsWrapperStyles {
    container: InjectableCss;
    leftSection: InjectableCss;
    rightSection: InjectableCss;
}

export const dealerDetailsWrapperStyles: DealerDetailsWrapperStyles = {
    container: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            margin: -15px;

            .branchFeaturesContentWrapper {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
                grid-gap: 15px;
            }

            .branchFeaturesContent {
                display: flex;
                align-items: center;

                > span {
                    width: 65px;
                    min-width: 65px;
                    margin-right: 10px;
                }

                p {
                    margin: 0;
                }
            }
        `,
    },
    leftSection: {
        css: css`
            flex: 1 0 450px;
            padding: 15px;
            min-width: 0;
            ${screen("lte", "sm")`
                flex: 1 1 100%;
            `}
        `,
    },
    rightSection: {
        css: css`
            flex: 0 0 550px;
            padding: 15px;
            min-width: 0;
            ${screen("lte", "md")`
                flex: 1 0 50%;
            `}
            ${screen("lte", "sm")`
                flex: 1 1 100%;
            `}
        `,
    },
};

const styles = dealerDetailsWrapperStyles;

type Props = WidgetProps;

const DealerDetailsWrapper: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.leftSection}>
                <Zone contentId={id} zoneName="content0" />
            </StyledWrapper>
            <StyledWrapper {...styles.rightSection}>
                <Zone contentId={id} zoneName="content1" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: DealerDetailsWrapper,
    definition: {
        allowedContexts: [DealerDetailsPageContext],
        group: "Dealer Details",
    },
};

export default widgetModule;
